<template>
    <v-col cols="12" style="position: unset">
        <v-row v-if="!reportType">
            <upload-widget v-for="item in cardItems" :key="item.index" :item="item">
                <template #action>
                    <v-btn :color="item.color || 'primary'" rounded small outlined block @click="switchToReport(item)"
                        >{{ t('reports::button.view_report') }}
                        <v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                </template>
            </upload-widget>
        </v-row>
        <div v-else-if="reportType === 'mhbu-results'">
            <component :is="'mhbu-reports-component'"></component>
        </div>
        <div v-else>
            <component :is="'trackers-tabs-component'"></component>
        </div>
    </v-col>
</template>

<script>
export default {
    name: 'TrackerReportIndexComponent',
    components: {},
    props: {
        listRoutes: {
            type: Object,
            required: true,
            default: null,
        },
    },
    data() {
        return {
            reportsType: ['mhbu-results', 'rechallenged-patients', 'red-results', 'amber-results'],
        };
    },
    computed: {
        reportType() {
            return this.$store.state.trackers.type;
        },
        trackers() {
            return this.$store.state.trackers;
        },
        urlReportType() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('type');
        },
        cardItems() {
            return this.$store.state.trackers.cardItems;
        },
    },
    mounted() {
        this.setItems();
        this.setReportType();
        this.setTabsItems();
    },
    methods: {
        switchToReport(item) {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('type', item.type);
            return (window.location.search = urlParams);
        },
        setItems() {
            const items = new Array();
            Object.keys(this.listRoutes).forEach((route) => {
                let item = {
                    title: null,
                    route: null,
                    endpoint: this.listRoutes[route],
                    type: route,
                    color: 'primary',
                };
                switch (route) {
                    case this.reportsType[0]:
                        item.title = t('reports::trackers.title.mhbu-results');
                        item.route = 'api.v1.trackers.mhbu-results.index';
                        item.type = this.reportsType[0];
                        break;
                    case this.reportsType[1]:
                        item.title = t('reports::trackers.title.rechallenged-patients');
                        item.route = 'api.v1.trackers.rechallenged-patients.index';
                        item.type = this.reportsType[1];
                        break;
                    case this.reportsType[2]:
                        item.title = t('reports::trackers.title.red-results');
                        item.color = 'red';
                        item.route = 'api.v1.trackers.red-results.index';
                        item.type = this.reportsType[2];
                        break;
                    case this.reportsType[3]:
                        item.title = t('reports::trackers.title.amber-results');
                        item.color = 'amber';
                        item.route = 'api.v1.trackers.amber-results.index';
                        item.type = this.reportsType[3];
                        break;
                    default:
                        return;
                }
                return items.push(item);
            });
            this.$store.dispatch('trackers/setCardItems', items);
        },
        setTabsItems() {
            const items = new Array();
            Object.keys(this.listRoutes).forEach((route) => {
                let item = {
                    title: null,
                    component: null,
                    route: null,
                    endpoint: this.listRoutes[route],
                };
                switch (route) {
                    case this.reportsType[0]:
                        return;
                    case this.reportsType[1]:
                        item.title = t('reports::trackers.title.rechallenged-patients');
                        item.component = 're-challenged-data-table';
                        item.route = 'api.v1.trackers.rechallenged-patients.index';
                        item.type = this.reportsType[1];
                        break;
                    case this.reportsType[2]:
                        item.title = t('reports::trackers.title.red-results');
                        item.component = 'red-results-data-table';
                        item.color = 'red';
                        item.route = 'api.v1.trackers.red-results.index';
                        item.type = this.reportsType[2];
                        break;
                    case this.reportsType[3]:
                        item.title = t('reports::trackers.title.amber-results');
                        item.component = 'amber-results-data-table';
                        item.color = 'amber';
                        item.route = 'api.v1.trackers.amber-results.index';
                        item.type = this.reportsType[3];
                        break;
                    default:
                        return;
                }
                return items.push(item);
            });
            this.$store.dispatch('trackers/setTabsItems', items);
        },
        setReportType() {
            if (!this.urlReportType) {
                return;
            }
            if (!this.reportsType.includes(this.urlReportType)) {
                return;
            }
            return this.$store.dispatch('trackers/setType', this.urlReportType);
        },
    },
};
</script>
